<template>
  <div class="contact-us">
    <div class="contact-us__top">
      <img class="contact-us__top__img" src="../assets/image/contactUs_1.png" alt="">
      <div class="contact-us__top__text1">
        <p>以消费者运营为核心</p>
        <p>打通品效全链路的新零售模式</p>
        </div>
      <div class="contact-us__top__text2">
        <p>TAKE CONSUMER OPERATION AS THE CORE</p>
        <p>BREAK THROUGH THE WHOLE LINK OF THE NEW RETAIL MODEL</p>
      </div>
    </div>
    <div class="contact-us__middle">
      <div class="contact-us__middle__title">
        <p>联系我们</p>
        <p>CONTACT US</p>
      </div>
      <div class="contact-us__middle__text">
        <div class="contact-us__middle__text__container">
          <div :style="{width:'600px'}">
            <el-amap vid="amap" :plugin="plugin" class="amap-demo" :center="center">
            </el-amap>
          </div>
          <div class="info">
            <div>
              <p>客服电话</p>
              <p>400-123-4567</p>
            </div>
            <div>
              <p>公司邮箱</p>
              <p>yuelian@Linda.com</p>
            </div>
            <div>
              <p>总部地址</p>
              <p>上海市青浦区华徐公路685号6栋</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from 'vue-amap';
import Vue from 'vue'
Vue.use(AMap);

  // 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: 'f82a3a90daa9c7de5897400f1a8cfc9b',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation']
});
export default {
  name: 'ContactUs',
  data () {
    const self = this;
    return {
            center: [121.59996, 31.197646],
            lng: 0,
            lat: 0,
            loaded: false,
            plugin: [{
              enableHighAccuracy: true,//是否使用高精度定位，默认:true
              timeout: 100,          //超过10秒后停止定位，默认：无穷大
              maximumAge: 0,           //定位结果缓存0毫秒，默认：0
              convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
              showButton: true,        //显示定位按钮，默认：true
              buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
              showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
              showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
              panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
              zoomToAccuracy:true,//定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
              extensions:'all',
              pName: 'Geolocation',
              events: {
                init(o) {
                  // o 是高德地图定位插件实例
                  o.getCurrentPosition((status, result) => {
                    console.log(result)
                    if (result && result.position) {
                      self.lng = result.position.lng;
                      self.lat = result.position.lat;
                      self.center = [self.lng, self.lat];
                      self.loaded = true;
                      self.$nextTick();
                    }
                  });
                }
              }
            }]
          }
  }
}
</script> 

<style lang="scss" scoped>
.contact-us{
  &__top{
    position: relative;
    width: 100%;
    &__img{
      width: 100%;
      min-width: 1440px;
      max-width: 1920px;
    }
    &__text1{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #fff;
      font-size: 40px;
      top: 280px;
      line-height: 50px;
    }
    &__text2{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #F8F8F8;
      font-size: 15px;
      top: 380px;
      line-height: 24px;
      letter-spacing:3px;
    }
  }
  &__middle{
    margin: 140px auto;
    &__title{
      font-size: 40px;
      color: #333;
      width: 880px;
      text-align: center;
      margin: 0 auto;
      height: 60px;
      position: relative;
      p:first-child{
          font-size: 40px;
          margin-bottom: -15px;
          font-family: webfont__bold;
      }
      p:last-child{
        font-size: 34px;
        opacity: 0.07;
      }
    }
    &__text{
      width: 1400px;
      margin: 72px auto;
      font-size: 14px;
      text-align: left;
      color: #666;
      background-color: #fff;
      border-radius: 20px;
      line-height: 30px;
      &__container{
        padding: 20px;
        display: flex;
        justify-content: flex-start;
        .info{
          flex: 1;;
          margin: 45px 0px 70px 48px;
          div{
            height: 100px;
            border-bottom: 1px solid #eee;
            p:first-child{
              color: #666;
              font-size: 14px;
              margin-top: 25px;
            }
            p:last-child{
              color: #333;
              font-size: 20px;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contactUs.vue